import React, { Component } from 'react';
import { Field } from 'redux-form';
import DropDownInput from '../../../app/common/Form/DropDownInput';
import BanksDropdown from '../../SearchableDropDowns/BanksDropdown';
import CreditCardInputBox from './CreditCardInputBox';
import StoredCardOption from '../../savedCards/component/StoredCardOption';

// Default Pay With Options
const payWith = [
  { key: 'creditdebit', text: 'Credit/Debit Card', value: '1' },
  { key: 'storedcards', text: 'Saved Cards', value: '2' },
  { key: 'netbanking', text: 'Netbanking', value: '3' }
];

export default class PayWithDropDown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cards: this.props.cards,
      defaultPaymentOption: '1',
      showSelectBank: false,
      showCreditCardInputBox: false,
      showStoreCardOptions: true,
      netbankSelect: ''
    }
  }

  static getDerivedStateFromProps(nextProps){
    return { defaultPaymentOption: nextProps.cards.length > 0 ? '2' : '1'};
  }

  resetCards = () => {
    const func = this.props.resetCreditCardField;

    if (typeof func === 'function') {
      func();
    }
  }

  handlePayWithChange = value => {
    if (value[0] === '3') {
      // reset credit card input box
      this.resetCards();
      
      // Show net banking options
      this.setState({
        showSelectBank: true,
        showCreditCardInputBox: false,
        showStoreCardOptions: false,
      });
    } else if (value[0] === '2') {
      // reset credit card input box
      this.resetCards();

      // Show stored card options
      this.setState({
        showSelectBank: false,
        showCreditCardInputBox: false,
        showStoreCardOptions: true,
        netbankSelect: '' // reset netbanking
      });
    } else {
      // Show credit card options
      this.setState({
        showSelectBank: false,
        showCreditCardInputBox: true,
        showStoreCardOptions: false,
        netbankSelect: '' // reset netbanking
      });
    }
  };

  selectStoredCard = (card) => {
    if(this.state.showStoreCardOptions && typeof card === 'object' && card.hasOwnProperty('cvv')) {
      // Default to stored Card
      card['paymentMethod'] = '2';
      this.props.selectStoredCard(card);
    }
  }

  render() {
    const {
      defaultPaymentOption,
      showSelectBank,
      showCreditCardInputBox,
      showStoreCardOptions
    } = this.state;
    return (
      <React.Fragment>
        <h4>Pay with</h4>
        <Field
          name="paymentMethod"
          type="text"
          component={DropDownInput}
          options={payWith}
          onChange={this.handlePayWithChange}
          placeholder="Pay With"
          defaultValue={defaultPaymentOption}
        />
        {showSelectBank && <BanksDropdown name="payment_option" value={this.state.netbankSelect} />}
        {showCreditCardInputBox && <CreditCardInputBox />}
        {showStoreCardOptions && <StoredCardOption select={this.selectStoredCard.bind(this)} />}
      </React.Fragment>
    );
  }

  componentDidMount() {
    const { cards } = this.props;

    if (Array.isArray(cards) && cards.length > 0 ) {
      this.setState({
        defaultPaymentOption: '2',
        showSelectBank: false,
        showCreditCardInputBox: false,
        showStoreCardOptions: true,
      });
    } else {
      this.setState({
        defaultPaymentOption: '1',
        showSelectBank: false,
        showCreditCardInputBox: true,
        showStoreCardOptions: false,
      });
    }
  }
}